// actions/form.actions.ts
import { createAction, props } from '@ngrx/store';

import { EditorFormEntity } from '../models/form.models';

export const resetForm = createAction(
  '[Form] Reset Form',
  props<{ entity: string }>(),
);

export const submitForm = createAction(
  '[Form] Submit Form',
  props<{ entity: string; formData: any }>(),
);

export const submitFormSuccess = createAction(
  '[Form] Submit Form Success',
  props<{
    entity: EditorFormEntity;
    object: any;
    isCreated: boolean;
    toastMessage?: string;
  }>(),
);

export const submitFormFailure = createAction(
  '[Form] Submit Form Failure',
  props<{ entity: EditorFormEntity; error: any }>(),
);
